module.exports = __webpack_public_path__ + "static/media/EmilyRudd1024751.0a7dad54.png";